import clsx from "clsx";

const InputCheckbox = ({ className, id, hasError, register, rules, children }) => (
  <div className={clsx("flex space-x-3 w-full", className)}>
    <input
      {...register(id, rules)}
      type="checkbox"
      id={id}
      className={clsx(
        "flex-shrink-0 w-5 h-5 bg-white checked:bg-blue rounded-full checked:border-2 checked:border-white appearance-none cursor-pointer hover:outline-blue-900",
        hasError ? "outline-red" : "outline-blue"
      )}
    />
    <label htmlFor={id} className={clsx(hasError && "text-red")}>
      {children}
    </label>
  </div>
);

export default InputCheckbox;
